// import { LoadingOverlay } from '@mantine/core';
// import { useState } from 'react';
// import { useTranslation } from 'react-i18next';

const UsagePage = () => {
  // const { t } = useTranslation();

  // const [loading, setLoading] = useState(false);

  return (
    <div style={{ position: 'relative', minHeight: '80vh' }}>
      {/* <LoadingOverlay visible={loading} /> */}
      UsagePage
    </div>
  );
};

export default UsagePage;
